/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModulePermissionWithRelations } from './modulePermissionWithRelations';


/**
 * (tsType: ModuleWithRelations, schemaOptions: { includeRelations: true })
 */
export interface ModuleWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    label: string;
    icon?: string;
    routerLink?: string;
    code?: string;
    parentId?: string;
    order?: number;
    showInMenu?: boolean;
    external?: boolean;
    isNew?: boolean;
    platforms?: Array<ModuleWithRelations.PlatformsEnum>;
    /**
     * En false se oculta en todas las plataformas
     */
    isEnabled?: boolean;
    /**
     * Ruta de Flutter del módulo en la app
     */
    mobileRoute?: string | null;
    /**
     * Lugar en la navegación de la app
     */
    navSlot?: ModuleWithRelations.NavSlotEnum | null;
    /**
     * Orden dentro de navSlot en la app
     */
    navOrder?: number | null;
    modulePermissions?: Array<ModulePermissionWithRelations>;
}
export namespace ModuleWithRelations {
    export type PlatformsEnum = 'web' | 'ios' | 'android';
    export const PlatformsEnum = {
        Web: 'web' as PlatformsEnum,
        Ios: 'ios' as PlatformsEnum,
        Android: 'android' as PlatformsEnum
    };
    export type NavSlotEnum = 'bottom' | 'menu' | 'fab' | 'hidden' | 'null';
    export const NavSlotEnum = {
        Bottom: 'bottom' as NavSlotEnum,
        Menu: 'menu' as NavSlotEnum,
        Fab: 'fab' as NavSlotEnum,
        Hidden: 'hidden' as NavSlotEnum,
        Null: 'null' as NavSlotEnum
    };
}


